const LOCATION_BICYCLES_INFO_FORM = {
  columns: [
    {
      label: 'bicycles.number_header',
      field: 'number',
      ordering: true
    },
    {
      label: 'bicycles.status_header',
      field: 'status',
      ordering: true,
      translate: true,
      getValue(raw) {
        return 'bike_status.' + raw.status;
      }
    },
    {
      label: 'bicycles.lock_header',
      field: 'lockMacAddress',
      ordering: true
    },
    {
      label: 'bicycles.power_level_header',
      field: 'powerLevel',
      ordering: true,
      getStyle(raw) {
        if (!raw.lastScan) {
          return {textAlign: 'center', width: '48px', display: 'block', textWrap: 'nowrap'};
        }

        const lastScan = new Date(raw.lastScan);
        const expiryScanDate = new Date(lastScan).setDate(lastScan.getDate() + 30);

        if (raw.powerLevel && expiryScanDate > new Date().getTime()) {
          if (expiryScanDate < new Date().getTime()) {
            return {color: '#f44336', textAlign: 'center', width: '48px', display: 'block', textWrap: 'nowrap'};
          }

          if (raw.powerLevel >= 80) {
            return {color: '#4CAF50', textAlign: 'center', width: '48px', display: 'block', textWrap: 'nowrap'};
          } else if (raw.powerLevel >= 50) {
            return {color: '#FF9800', textAlign: 'center', width: '48px', display: 'block', textWrap: 'nowrap'};
          } else if (raw.powerLevel < 50) {
            return {color: '#f44336', textAlign: 'center', width: '48px', display: 'block', textWrap: 'nowrap'};
          }
        }

        return {textAlign: 'center', width: '48px', display: 'block', textWrap: 'nowrap'};
      },
      getValue(raw) {
        if (!raw.lastScan) {
          return 'power_level.none';
        }

        const lastScan = new Date(raw.lastScan);
        const expiryScanDate = new Date(lastScan).setDate(lastScan.getDate() + 30);

        if (raw.powerLevel && expiryScanDate > new Date().getTime()) {
          if (raw.powerLevel >= 80) {
            return 'power_level.good';
          } else if (raw.powerLevel >= 50) {
            return 'power_level.low';
          } else if (raw.powerLevel < 50) {
            return 'power_level.bad';
          }
        }

        return 'power_level.none';
      }
    },
    {
      label: 'bicycles.last_scan_header',
      field: 'lastScan',
      ordering: true,
      getStyle(raw) {
        if (!raw.lastScan) {
          return {};
        }

        const lastScan = new Date(raw.lastScan);
        const expiryScanDate = new Date(lastScan).setDate(lastScan.getDate() + 30);

        if (expiryScanDate < new Date().getTime()) {
          return {color: '#f44336'};
        }

        return {};
      },
      getValue(raw) {
        return raw.lastScan ? raw.lastScan : '-'
      }
    }
  ],
  footerLabel: 'bicycles.footer_label'
}

export default LOCATION_BICYCLES_INFO_FORM;
